import { render, staticRenderFns } from "./UcFixedAssetRentalCard.yaml?vue&type=template&id=0e5705d4&component"
import script from "./UcFixedAssetRentalCard.yaml?vue&type=script&lang=ts&component"
export * from "./UcFixedAssetRentalCard.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports